import { Box, CircularProgress } from "@mui/material"
import moment from "moment"
import { useContext, useState } from "react"
import { ParagraphText } from "../../../../../Libraries"
import { LanguageContext } from "../../../../../context/LanguageContext"
import { DownloadIconBlack, DeleteNewIcon } from "../../../../../assets/icons/icon"
import styles from "./../AllTransaction.module.css"
import { handleApi } from "../../../../../apis"
import { DELETETRANSACTIONSTATEMENT, RETRYTRANSACTIONSTATEMENT } from "../../../../../apis/configuration"
import { useSnackbar } from "../../../../../context/SnackbarContext"
import { analytics, triggerLogEvent } from "../../../../../config/firebase"
import ConfirmationModal from "../../../../common/Modals/ConfirmationModal"

const StatementItemList = ({ item = {}, onRefetch = () => { } }) => {
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [retryLoading, setRetryLoading] = useState(false);
    const [I18n] = useContext(LanguageContext);
    const { showSnackbar } = useSnackbar();
    const { start_date, end_date, name, status, file_url, report_id } = item;
    const isGenerated = status === "GENERATED";
    const isFailed = status === "FAILED";

    const handleCloseModal = () => setDeleteConfirmation(false);

    const handleDownload = async () => {
        triggerLogEvent(analytics, "emi_wlt_txn_report_download", { file_url, name });

        if (!file_url) {
            showSnackbar({ message: I18n.download_url_not_available, severity: "error" });
            return;
        }

        if (!navigator.onLine) {
            showSnackbar({ message: I18n.internet_connection_is_required, severity: "error" });
            return;
        }

        try {
            const response = await fetch(file_url);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const safeFileName = (name && name.endsWith(".pdf") ? name : `${name || "statement"}.pdf`).replace(/[^\w\-. ]/g, "_");

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = safeFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

            showSnackbar({ message: I18n.pdf_downloaded_successfully, severity: "success" });
        } catch (error) {
            showSnackbar({ message: I18n.failed_to_download_file, severity: "error" });
            console.error("Download error:", error);
        }
    };
    const handleDelete = async () => {
        triggerLogEvent(analytics, "emi_wlt_txn_report_delete", { report_id, name });
        setDeleteLoading(true);
        const resp = await handleApi(DELETETRANSACTIONSTATEMENT, { report_id })
        setDeleteLoading(false);
        handleCloseModal();
        onRefetch();
    };

    const handleRetry = async () => {
        if (retryLoading) return;
        triggerLogEvent(analytics, "emi_wlt_txn_report_retry", { report_id, name });
        setRetryLoading(true);
        try {
            await handleApi(RETRYTRANSACTIONSTATEMENT, { report_id });
            onRefetch();
        } catch (error) {
            showSnackbar({ message: error?.response?.data?.message || I18n.something_went_wrong, severity: "error" });
        }
        setRetryLoading(false);
    };

    return (
        <Box
            id={`bank_statement_row_${report_id}`}
            className="invoiceListTableBody accountTableHeaderMain" >
            <Box className={`invListTableHeaderCol textLeft ${styles.statementDurationCol}`}>
                <Box className={styles.statementDateCell}>
                    <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
                        {`${moment(start_date).format("DD MMM YYYY")} - ${moment(end_date).format("DD MMM YYYY")}`}
                    </ParagraphText>
                    {isFailed && (
                        <span className={styles.statementFailedChip}>{I18n.failed}</span>
                    )}
                </Box>
            </Box>
            <Box className={`invListTableHeaderCol ${styles.statementActionCol} ${styles.statementActions}`}>
                {isGenerated ? (
                    <Box className={styles.statementIconActions}>
                        {deleteLoading ? <CircularProgress size={16} /> : <DeleteNewIcon
                            id={`bank_statement_delete_btn_${report_id}`}
                            width={16}
                            height={16}
                            className="cursorPointer"
                            onClick={() => setDeleteConfirmation(true)}
                        />}
                        <DownloadIconBlack
                            id={`bank_statement_download_btn_${report_id}`}
                            width={16}
                            height={16}
                            className="cursorPointer"
                            onClick={handleDownload}
                        />
                    </Box>
                ) : isFailed ? (
                    retryLoading ? <CircularProgress size={20} /> : (
                        <ParagraphText
                            id={`bank_statement_retry_btn_${report_id}`}
                            className={`fontSize14 fontWeight500 cursorPointer ${styles.statementTryAgain}`}
                            onClick={handleRetry}
                        >
                            {I18n.try_again}
                        </ParagraphText>
                    )
                ) : (
                    <span className={styles.statementInProcessChip}>
                        {I18n.in_progress}
                    </span>
                )}
            </Box>
            <ConfirmationModal
                title={I18n.are_you_sure_you_want_to_delete_statement}
                message={I18n.this_action_cannot_be_undone}
                confirmText={I18n.delete}
                open={deleteConfirmation}
                onConfirm={handleDelete}
                onClose={handleCloseModal}
                id="account_detail_delete_transaction_modal"
                loading={deleteLoading}
            />
        </Box>
    )
}
export default StatementItemList;